import { useCallback, useContext } from "react";

import styled from "styled-components";

import FnrTypography from "FnrTypography";
import { COVER_TRANSACTION_FEES, addOntypes } from "Giving/constants";

import FnrInput2 from "UI/FnrInput2";
import FnrVerticalGap from "UI/commonContainers/FnrVerticalGap";

import { decToPercent } from "Utilities/stringTransformers";

import { useUpdateAddOnAmounts } from "../../stateHooks";

import { EditorContext } from "./Editor";
import FlexSwitch from "./FlexSwitch";

const InputLimiter = styled("div")`
  ${({ $fullWidth }) => {
    if ($fullWidth) return "width: 60%";
    return `min-width: 100px;
    max-width: 100px;`;
  }}
`;

const AccordionContents = () => {
  const {
    percentage,
    type,
    fundName,
    description,
    isEditable,
    amount,
    horizontal,
    addOnGiftID,
  } = useContext(EditorContext);
  const updateAddOnAmounts = useUpdateAddOnAmounts();

  const handleSetValue = useCallback(
    (value) => {
      if (Number(value) > 9998) return;
      updateAddOnAmounts({
        addOnGiftID,
        newGiftAmount: value,
      });
    },
    [updateAddOnAmounts, addOnGiftID]
  );

  return (
    <FlexSwitch horizontal={horizontal} $addMarginLeft>
      <FnrVerticalGap gap={4}>
        <FnrTypography fontSize="xs" color="textSecondary">
          {percentage ? `${decToPercent(percentage)} - ` : ""}
          {type === addOntypes.COVER_THE_FEES
            ? COVER_TRANSACTION_FEES
            : fundName}
        </FnrTypography>
        {Boolean(description) && (
          <FnrTypography fontSize="sm" color="textSecondary">
            {description}
          </FnrTypography>
        )}
      </FnrVerticalGap>
      {isEditable && (
        <InputLimiter $fullWidth={!horizontal}>
          <FnrInput2
            size="sm"
            type="currency"
            value={Number(amount) > 0 ? amount : ""}
            setValue={handleSetValue}
            aria-label="change-add-on-gift-amount"
          />
        </InputLimiter>
      )}
    </FlexSwitch>
  );
};

export default AccordionContents;
